import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react'
import { connect } from 'react-redux'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import { saveNavTheme } from '../../reducers/nav'

import { useNavigate } from 'react-router-dom'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../constants/routes'
import { fetchApiData } from '../../actions/api'

import { completeAnimatingIn, completeAnimatingOut, completePreloading } from '../../reducers/nav'
import { calcComponentState } from '../../fxs/component-utils'

import LocationTile from './location-tile'
import LocationCarouselTile from './location-carousel-tile'
import anime from 'animejs'
import { setMusicSource } from '../../reducers/sound'
import CarouselNextArrow from '../elements/carousel-next-arrow'
import CarouselPrevArrow from '../elements/carousel-prev-arrow'
import { ReactComponent as Squiggle } from '../../assets/svgs/squiggle-01.svg'

const highwaySteps = [[[0, 0], [151, 0], [156, 27], [167, 66], [170, 103], [214, 234], [221, 273], [247, 297], [251, 317], [253, 359],
    [264, 390], [264, 416], [283, 442], [298, 490], [336, 543], [341, 582], [343, 610], [366, 720], [379, 740], [383, 788], [420, 842], [412, 876],
    [415, 915], [429, 955], [445, 1000], [0, 1000], [12, 955], [14, 915], [30, 876], [14, 842], [22, 788], [34, 740], [39, 720], [53, 610], [53, 582],
    [28, 543], [8, 490], [-12, 442], [-12, 416], [0, 390], [5, 359], [14, 317], [14, 297], [7, 273], [14, 234], [14, 103], [28, 66], [14, 28]]]

const makeInitialHighwayPoints = (width, height) => {
    let allPoints = []
    let firstStep = highwaySteps[0]
    firstStep.forEach(point => {
        let xPos = width * 0.35
        let yPos = point[1] / 1000 * height
        allPoints.push(`${xPos} ${yPos}`)
    })
    return allPoints.join(' ')
}

const makeHighwayPointSteps = (width, height) => {
    let allSteps = []
    highwaySteps.forEach((step, index) => {
        let allPoints = []
        step.forEach(point => {
            let xPos = (point[0] / 1000 * width) + (width * (0.35 - (0.15 * (index + 1))))
            // let xPos = (point[0] / 1000 * width) + (width * (0.3))
            let yPos = point[1] / 1000 * height
            allPoints.push(`${xPos} ${yPos}`)
        })
        allSteps.push(allPoints.join(' '))
    })
    return allSteps
}

const makeHighwayPoints = (width, height) => {
    let allPoints = []
    let lastStep = highwaySteps[highwaySteps.length - 1]
    lastStep.forEach(point => {
        let xPos = point[0] / 1000 * width + width * 0.2
        let yPos = point[1] / 1000 * height
        allPoints.push(`${xPos} ${yPos}`)
    })
    return allPoints.join(' ')
}

const mapStateToProps = (state) => {
    const { nav, locations } = state
    const { deviceType, deviceHeight, width, height } = state.ui
    return {
        navState: nav,
        uiDeviceType: deviceType,
        uiDeviceHeight: deviceHeight,
        uiWidth: width,
        uiHeight: height,
        locations
    }
}

const ClayvilleIndex = ({ dispatch, navState, uiDeviceType, uiWidth, uiHeight, uiDeviceHeight, locations }) => {
    const [highwayPoints, setHighwayPoints] = useState(null)
    const [activeLocationId, setActiveLocationId] = useState(null)
    const [activeSlide, setActiveSlide] = useState(0)
    const [manualChange, setManualChange] = useState(false)
    const [containerDimensions, setContainerDimensions] = useState(null)
    let sliderRef = useRef(null)

    const componentName = 'Clayville'
    const navigate = useNavigate()
    // console.log(loc)
    const highwayObject = locations.find(l => l.title === 'West Calabama State Highway 34')
    const highwayId = highwayObject?.uuid

    // TODO: make container ref to get width / height for the clipping path calculations
    const locationContainerRef = useCallback(node => {
        if (node !== null) {
            let dims = node.getBoundingClientRect()
            setContainerDimensions({
                width: dims.width,
                height: dims.height
            })
        }
    }, [])

    useEffect(() => {
        if (containerDimensions) {
            let openPoints = makeInitialHighwayPoints(containerDimensions.height, containerDimensions.width)
            setHighwayPoints(openPoints)
            // wait half a second
            setTimeout(() => {
                openTear()
            }, 500)
        }
    }, [containerDimensions])

    useEffect(() => {
        let node = document.getElementById('location-container')
        if (node) {
            let dims = node.getBoundingClientRect()
            setHighwayPoints(makeHighwayPoints(dims.width, dims.height))
        }
    }, [uiWidth, uiHeight])

    const componentState = useMemo(() => {
        return calcComponentState(componentName, navState)
    }, [navState, componentName])

    useEffect(() => {
        if (componentState === 'PRELOADING') {
            handlePreloadingState()
        } else if (componentState === 'ACTIVE') {
            if (navState.theme !== 'white') {
                dispatch(saveNavTheme('white'))
            }
        } else if (componentState === 'ANIMATING_IN') {
            handleAnimatingInState()
        } else if (componentState === 'ANIMATING_OUT') {
            handleAnimatingOutState()
        }
    }, [componentState])

    const handlePreloadingState = async () => {
        dispatch(fetchApiData(apiResourceEndpoint('clayville', 'LIST')))
            .then(() => {
                dispatch(completePreloading())
            })
    }

    const handleAnimatingInState = async () => {
        if ((uiDeviceType === 'mobile' || uiDeviceType === 'tablet' || uiDeviceType === 'intermediate') && (!activeLocationId && activeSlide > -1)) {
            let activeLocation = locations[0]
            setActiveLocationId(activeLocation.uuid)
            dispatch(completeAnimatingIn())
        }
        dispatch(setMusicSource('https://api.wayouttanoway.com/sites/default/files/2025-02/Henry-Concept-2-v2.mp3'))
    }

    const handleAnimatingOutState = async () => {
        const slideUp = await animateOutLocation()
        slideUp.finished.then(() => {
            setActiveLocationId(null)
            dispatch(completeAnimatingOut())
        })
    }

    const openTear = () => {
        const pointList = makeHighwayPointSteps(containerDimensions.width, containerDimensions.height)
        const opened = anime({
            targets: '.highway-shape',
            points: pointList,
            easing: 'easeInOutQuint',
            duration: 750
        })
        opened.finished.then(() => {
            // setHasOpened(true)
            setHighwayPoints(makeHighwayPoints(containerDimensions.width, containerDimensions.height))
            dispatch(completeAnimatingIn())
        })
    }

    const animateOutLocation = async () => {
        return anime({
            targets: '.story-swipe',
            keyframes: [
                { top: -1 * uiHeight }
            ],
            duration: 500,
            easing: 'easeInOutQuad'
        })
    }


    useEffect(() => {
        if (activeLocationId) {
            // jump to the location
            let idx = locations.findIndex(location => location.uuid === activeLocationId)
            sliderRef.slickGoTo(idx, true)
            setManualChange(true)
            setActiveSlide(idx)
        }
    }, [locations, activeLocationId])

    if (componentState === 'OFF' || componentState === 'PRELOADING') {
        if (activeLocationId) {
            setActiveLocationId(null)
            setActiveSlide(0)
        }
        return null
    }

    const handleLocationClick = (locationId) => {
        if (locationId === activeLocationId) {
            setActiveLocationId(null)
        } else {
            setActiveLocationId(locationId)
        }
    }

    const handleSlideChange = (idx) => {
        let slides = document.querySelectorAll('.slick-slide')
        slides.forEach(slide => {
            slide.classList.remove('slide-prev', 'slide-next', 'slide-current')
        })
        let newSlide = document.querySelectorAll(`[data-index='${idx}']`)[0]
        newSlide.classList.add('slide-current')
        newSlide.previousSibling.classList.add('slide-prev')
        newSlide.nextSibling.classList.add('slide-next')
    }

    const renderLocations = () => {
        let allLocations = []
        locations.filter(location => location.displayOrder > 0)
            .forEach(location => {
                allLocations.push(
                    <LocationTile
                        key={location.uuid}
                        location={location}
                        activeLocationId={activeLocationId}
                        onHandleLocationClick={handleLocationClick} />
                )
            })
        return allLocations
    }

    const handleStoryClick = () => {
        const location = locations.find(m => m.uuid === activeLocationId)
        let slideUp = anime.timeline({
            duration: 450,
            easing: 'easeInOutQuad'
        })
            .add({
                targets: '.story-swipe',
                top: 0
            })
            .add({
                targets: '.clayville-carousel-container',
                opacity: 0
            }, '+=100')
            .add({
                targets: '.location-swipe-name',
                opacity: 1
            }, '+=200')
            .add({
                targets: '.title-stroke svg path',
                strokeDashoffset: 0
            }, '+=200')
        slideUp.finished.then(() => {
            const locationRoute = buildRoutePath(routes.clayvilleView.path, { location: location.alias.substring(1) })
            // wait 500sm before navigating
            setTimeout(() => {
                navigate(locationRoute)
            }, 500)
        })
    }

    const renderLocationCarousel = () => {
        let allLocations = []
        locations.forEach(location => {
            allLocations.push(
                <LocationCarouselTile
                    key={location.uuid}
                    location={location}
                    handleStoryClick={handleStoryClick} />)
        })
        return allLocations
    }

    const renderLocationStartButton = () => {
        if (activeLocationId) {
            let activeLocation = locations[activeSlide]

            const handleKeyDown = (e) => {
                // Handle Enter or Space key press
                if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault()
                    handleStoryClick()
                }
            }
            return (
                <div
                    tabIndex="0"
                    role="button"
                    aria-label={`Discover ${activeLocation.title}`}
                    onKeyDown={handleKeyDown}
                    className="start-cta"
                    data-id={`Discover ${activeLocation.title}`}>
                    <div className="btn white" onClick={handleStoryClick}>
                        Discover {activeLocation.title}
                    </div>
                </div>
            )
        }
        return null
    }

    const renderStorySwipe = () => {
        const location = locations.find(l => l.uuid === activeLocationId)
        let invert = location?.color ? ['yellow', 'blue'].includes(location.color) : false
        if (location && activeLocationId) {
            return (
                <div className={`story-swipe ${location.color}-bg`}>
                    <div className="transition-background" style={{ backgroundImage: `url(${location.locationBackgroundImage?.url })`, mixBlendMode: `${invert ? 'screen' : 'color-burn'}` }} />
                    <div className="location-swipe-name">
                        <div>{location.title}</div>
                        <div className="title-stroke">
                            <Squiggle />
                        </div>
                    </div>
                </div>
            )
        }
        return null
    }

    let settings = {
        className: 'center',
        centerMode: true,
        infinite: true,
        centerPadding: '20%',
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <CarouselNextArrow />,
        prevArrow: <CarouselPrevArrow />,
        beforeChange: (current, next) => {
            // NOTE: If we use slickGoTo it doesnt call the afterChange event. It also has a race condition which removes the classes before the slide is actually changed.
            if (manualChange) {
                setTimeout(() => {
                    handleSlideChange(next)
                    setManualChange(false)
                }, 500)
            }
        },
        afterChange: current => {
            // remove all prev and next classes from the dom
            handleSlideChange(current)
            let activeLocation = locations[current]
            if (activeLocationId !== activeLocation.uuid) {
                setActiveLocationId(activeLocation.uuid)
            }
            setActiveSlide(current)
        }
    }

    if (uiDeviceType === 'mobile' || uiDeviceType === 'tablet' || uiDeviceHeight === 'height-short') {
        return (
            <div className={`clayville-carousel-container active`}>
                <Slider
                    ref={slider => {
                        sliderRef = slider
                    }}
                    {...settings}
                >
                    {renderLocationCarousel()}
                </Slider>
                {renderLocationStartButton()}
            </div>
        )
    }

    return (
        <>
            { activeLocationId &&
                <div className="breadcrumb clayville">
                    <div onClick={() => setActiveLocationId(null)}>Explore Clayville</div>
                </div>
            }
            <div className={`clayville-container ${activeLocationId ? 'inactive' : 'active'}`}>
                <div id="location-container" ref={locationContainerRef} className="container">
                    <svg id="highway-clip-wrapper" xmlns="http://www.w3.org/2000/svg">
                        <clipPath id="highway-clip">
                            <polygon className="highway-shape" points={highwayPoints} fill="white" />
                        </clipPath>
                    </svg>
                    <div className="highway-image">
                        <svg id="highway-shape-shadow" xmlns="http://www.w3.org/2000/svg">
                            <polygon className="highway-shape" points={highwayPoints} fill="none" strokeWidth="10" stroke="black" />
                        </svg>
                        <div className="highway-trigger" role="button" tabIndex="0" aria-label="View West Calabama State Highway 34"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                                    e.preventDefault()
                                    handleLocationClick(highwayId)
                                }
                            }}
                            onClick={() => handleLocationClick(highwayId)}
                        >
                            <img src="/clayville-images/highway.png" alt="highway"/>
                            <div className="location-name">
                            West Calabama State Highway 34
                            </div>
                        </div>
                    </div>
                    <div className="location-wrapper">
                        {renderLocations()}
                    </div>
                </div>
                {renderStorySwipe()}
            </div>
            <div className={`clayville-carousel-container ${activeLocationId ? 'active' : 'inactive'}`}>
                <Slider
                    ref={slider => {
                        sliderRef = slider
                    }}
                    {...settings}
                >
                    {renderLocationCarousel()}
                </Slider>
                {renderLocationStartButton()}
            </div>
        </>
    )
}

export default connect(mapStateToProps)(ClayvilleIndex)
